import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/YkZ8cAkm4wWJcYB3A';
export function Footer() {
  return <footer className="w-full bg-[#3A3A2E] text-[#F2EDE4] py-12 px-4 mt-auto" data-id="element-408">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-409">
        <div className="space-y-2" data-id="element-410">
          <h3 className="font-serif text-xl text-[#7C8062]" data-id="element-411">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-412">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-413">
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-414">
            <MapPinIcon className="h-4 w-4 text-[#7C8062]" data-id="element-415" />
            <span data-id="element-416">Klostergatan 7, Växjö</span>
          </a>
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-417">
            <ClockIcon className="h-4 w-4 text-[#7C8062]" data-id="element-418" />
            <span data-id="element-419">Se öppettider på Google Maps</span>
            <ExternalLinkIcon className="h-3 w-3 opacity-50" data-id="element-420" />
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-421">
            <PhoneIcon className="h-4 w-4 text-[#7C8062]" data-id="element-422" />
            <span data-id="element-423">0470-52 36 03</span>
          </div>
          <a href="mailto:info@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-424">
            <MailIcon className="h-4 w-4 text-[#7C8062]" data-id="element-425" />
            <span data-id="element-426">info@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-427">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}